import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ButtonsTranslations } from '~shared/components/buttons/buttons-translations.service';
import { FormLabelTranslationService } from '~shared/components/form-fields/translations/form-label-translations.service';
import { AuthenticationService } from '~core/services';
import { isPasswordValid, isPasswordSame } from '~shared/directives/form-validators';

/**
 * Component that handles the password reset logic
 */
@UntilDestroy()
@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html'
})
export class PasswordResetComponent implements OnInit, OnDestroy {
  public passwordResetForm: UntypedFormGroup;
  public passwordType: string = 'password';
  public submitted: boolean = false;
  public loadingModal: boolean = false;
  @Input() public passwordResetModal: boolean;
  @Output() public completed: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    public buttonsTranslations: ButtonsTranslations,
    public flTranslations: FormLabelTranslationService
  ) { }

  public ngOnInit(): void {
    this.passwordResetForm = this.formBuilder.group({
      password: [null, [Validators.required, isPasswordValid]],
      passwordRepeat: [null, [Validators.required, isPasswordValid]]
    }, { validators: isPasswordSame });
  }

  public ngOnDestroy(): void { }

  /**
   * Submits the form to the password reset API
   */
  public onSubmit(): void {
    this.submitted = true;
    if (this.passwordResetForm.valid) {
      this.authenticationService.passwordReset(this.passwordResetForm.value).pipe(untilDestroyed(this))
        .subscribe(() => {
          this.completed.emit('complete');
        });
    } else {
      this.completed.emit('incomplete');
    }
  }
}
